import React from 'react'
import { Modal, ModalBody } from "reactstrap";
import TranslatedText from '../../Common/TranslatedText';

export default function CreateServiceModal({
    createProjectModal,
    getModalToggleHandler,
    modalContentRefs,
    NavigateToCreate,
    setOTSroute,
    setOTSAutoOpen
}) {
    return (
        <div>
            <Modal
                className="about-modal create-pop-modal"
                isOpen={createProjectModal}
                toggle={getModalToggleHandler('createProject')}
            >
                <div ref={modalContentRefs.createProject}>
                    <button
                        className="btn close-button"
                        onClick={getModalToggleHandler('createProject')}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>

                    <div className="about-left">
                        <h2>Select a service type</h2>
                        <div className="post-type">
                            <div
                                className="post-type-sec">
                                <button style={{ background: 'transparent' }}
                                    onClick={() => NavigateToCreate("createpost", 1)}
                                >
                                    <h3>Post & Browse Projects (PBP)</h3>
                                </button>
                            </div>
                            <div
                                className="post-type-sec">
                                <button style={{ background: 'transparent' }}

                                    onClick={() => NavigateToCreate("createpost", 2)}
                                >
                                    <h3>Win-Business-Opportunities (WBO)</h3>
                                </button>
                            </div>
                            <div
                                className="post-type-sec">
                                <button style={{ background: 'transparent' }}
                                    onClick={() => NavigateToCreate("createpost", 3)}
                                >
                                    <h3>Part-Time-Job (PTJ)</h3>
                                </button>
                            </div>
                            <div
                                className="post-type-sec">
                                <button style={{ background: 'transparent' }}
                                    onClick={() => {
                                        NavigateToCreate("dashboard/myotsproducts");
                                        setOTSroute("Auctionitem");
                                        setOTSAutoOpen(true);
                                    }}
                                >
                                    <h3>Buy & Sell with Auction (BSA)</h3>
                                </button>
                            </div>
                            <div
                                className="post-type-sec">
                                <button style={{ background: 'transparent' }}
                                    onClick={() => {
                                        NavigateToCreate("dashboard/myotsproducts");
                                        setOTSroute("RentalProducts");
                                        setOTSAutoOpen(true);
                                    }}
                                >
                                    <h3>Turn Assets to Income (TAI)</h3>
                                </button>
                            </div>
                            <div
                                className="post-type-sec">
                                <button style={{ background: 'transparent' }}
                                    onClick={() => {
                                        NavigateToCreate("dashboard/myotsproducts");
                                        setOTSroute("ProductforSell");
                                        setOTSAutoOpen(true);
                                    }}
                                >
                                    <h3>Buy & Sell with Market (BSM)</h3>
                                </button>
                            </div>
                            <div
                                className="post-type-sec">
                                <button style={{ background: 'transparent' }}
                                    onClick={() => {
                                        NavigateToCreate("dashboard/myotsproducts");
                                        setOTSroute("Packageservice");
                                        setOTSAutoOpen(true);
                                    }}
                                >
                                    <h3>One-Time-Services (OTS)</h3>
                                </button>
                            </div>
                            <div
                                className="post-type-sec">
                                <button style={{ background: 'transparent' }}
                                    onClick={() => {
                                        NavigateToCreate("dashboard/myotsproducts");
                                        setOTSroute("MergersAcquisitions");
                                        setOTSAutoOpen(true);
                                    }}
                                >
                                    <h3><TranslatedText i18nKey="MAS1" /></h3>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
